import logo from './logo.svg';
import './App.css';
import Homepage from './Homepage.jsx';
import AulaMultimediale from './punti.jsx';
import Patenti from './patenti.jsx';

function App() {
  return (
  <Homepage/>
  );
}

export default App;
